module.exports = __webpack_public_path__ + "static/media/login-img.46004ef8.svg";